export default "__VITE_ASSET__oO9cTdK6__"